'use client';

import classnames from 'classnames';
import {
  DropdownItemProps,
  Dropdown as V3Dropdown,
  DropdownProps,
} from '@stadionhq-v3/base-ui';
import styles from './dropdown.module.scss';

function Dropdown<T extends DropdownItemProps>({
  classNames = [],
  transparent,
  ...props
}: DropdownProps<T>) {
  const classes = classnames(
    [
      styles.dropdown,
      styles.dropdownTokens,
      transparent && styles.transparent,
      props.theme?.themeId ? styles[props.theme.themeId] : styles.default1,
    ],
    classNames
  );

  return <V3Dropdown classNames={[classes]} {...props} />;
}

export default Dropdown;
